export const sendmail_loading = (state) => {
  return state.sendmail_loading;
};
export const subscribe_mail_loading = (state) => {
  return state.subscribe_mail_loading;
};
export const get_started_loading = (state) => {
  return state.get_started_loading;
};
